import React, { useEffect } from 'react'
import { Pagination, Table } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { fetchMessages, fetchMessagesPagination } from '../../../redux/action/messages/messages'
import MainLoading from '../../../utils/MainLoading'
import DashboardMainTitle from '../../dashboardTitle/DashboardMainTitle'
import DashboardContent from '../../dashboardWrapper/DashboardContent'
import Wrapper from '../../dashboardWrapper/Wrapper'
import moment from "moment-jalaali";
import { useTranslation } from 'react-i18next'

const Messages = () => {
    const dispatch = useDispatch()
    const messages = useSelector(state => state.messages)
    const {t} = useTranslation();
    const lang = localStorage.getItem('lang')

    useEffect(() => {
        if(!messages.messages.data) {
            dispatch(fetchMessages())
        }
    }, [])

    const handlePaginate = (e) => {
        e.preventDefault()
        dispatch(fetchMessagesPagination(e.target.href))
    }

    return (
        <Wrapper>
            <DashboardContent>
                <DashboardMainTitle> {t("dashboard_nav_messages_management")} </DashboardMainTitle>
                {messages.loading  ? <MainLoading /> :
                    messages.messages.data &&
                    messages.messages.data.length ?
                    <>
                    <Table responsive bordered>
                        <thead>
                            <tr>
                                <th className='text-center col-2'>{t("subject")}</th>
                                <th className='text-center col-4'>{t("message")}</th>
                                <th className='text-center col-2'>{t("user name")}</th>
                                <th className='text-center col-2'>{t("email")}</th>
                                <th className='text-center col-2'>{t("date")}</th>
                            </tr>
                        </thead>
                        <thead>
                        {messages.messages.data.map(message => (
                            <tr key={message.id} id={message.id}>
                                <td className='align-top text-center col-2 text-primary' style={{fontSize: '0.85rem'}}>{message.type}</td>
                                <td className='align-top text-right col-4' style={{maxWidth: '300px', fontSize: '0.85rem'}}>{message.description} </td>
                                <td className='align-top text-center col-2' style={{fontSize: '0.85rem'}}>{message.name}</td>
                                <td className='align-top text-center col-2' style={{fontSize: '0.85rem'}}>{message.email}</td>
                                <td className='align-top text-center col-2' style={{fontSize: '0.85rem'}}>
                                    {lang === 'en'?
                                        message.created_at.substr(11, 5)+' - '+message.created_at && message.created_at.substr(0, 10)
                                    :
                                        message.created_at.substr(11, 5)+' - '+moment(message.created_at && message.created_at.substr(0, 10), 'YYYY-M-D').format('jYYYY/jM/jD')
                                    }
                                </td>
                            </tr>
                            ))}
                        </thead>
                    </Table>
                    <div className='pagination_container mt-3'>
                        {messages.messages.links.length &&
                            <Pagination>
                                {messages.messages.links.map(link => (
                                    <Pagination.Item href={link.url} disabled={link.url ? false : true} active={link.active} key={link.label} onClick={id => {handlePaginate(id)}}>
                                        {link.label.replace('&laquo;', '').replace('&raquo;', '')}
                                    </Pagination.Item>
                                ))}
                            </Pagination>
                        }
                    </div>
                    </>
                : 
                    <h6 className="text-center"> {t("There is no message")} </h6>
                }
            </DashboardContent>
        </Wrapper>
    )
}

export default Messages
